import React from 'react';
import { Container } from 'react-bootstrap';
import { RedocStandalone } from 'redoc';
import '../App.css';

const ApiComponent =() => {
    
    var spec ="https://remitee-moneytransfer-test.azurewebsites.net/swagger/v1/swagger.json";
    return (
        
        <Container className="home" fluid={true}>
          <RedocStandalone spec={spec}/>
        </Container>
    );

}
export default ApiComponent;
